module.exports = __webpack_public_path__ + "static/img/default_new_zh-TW.5cca72f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/v2/default/default_new_zh-TW.png
// module id = ctL5
// module chunks = 24